<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text class="orangehrm-main-title">
        {{ $t('performance.add_kpi_categories') }}
      </oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="2" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="categoriesKpi.name"
                :label="$t('general.name')"
                required
                :rules="rules.name"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="categoriesKpi.weight"
                :label="$t('performance.kpi_categories_weight')"
                required
                :rules="rules.weight"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />
        <br />
        <oxd-form-actions>
          <required-text />
          <oxd-button
            type="button"
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {
  required,
  shouldNotExceedCharLength,
} from '@ohrm/core/util/validation/rules';
import {APIService} from '@/core/util/services/api.service';

const initialSubCategoriesKpi = {
  name: '',
  weight: null,
};

export default {
  name: 'KpiCategoriesSave',
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/performance/kpi-categories',
    );

    return {
      http,
    };
  },
  data() {
    return {
      isLoading: false,
      categoriesKpi: {...initialSubCategoriesKpi},
      rules: {
        name: [required, shouldNotExceedCharLength(100)],
        weight: [required],
      },
    };
  },
  methods: {
    onCancel() {
      navigate('/performance/categoriesKpi');
    },
    onSave() {
      this.isLoading = true;
      this.http
        .create({
          name: this.categoriesKpi.name,
          weight: this.categoriesKpi.weight,
        })
        .then(() => {
          return this.$toast.saveSuccess();
        })
        .then(() => {
          this.onCancel();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-module-field-row {
  grid-column-start: 1;
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
}

.orangehrm-module-field-label {
  @include oxd-input-control();
  padding: 0;
  flex-basis: 75%;
}
</style>
